// CookieBanner.jsx
import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = (type) => {
    localStorage.setItem('cookieConsent', type);
    setShow(false);
  };

  if (!show) return null;

  const banner = (
    <div className="fixed bottom-4 left-4 right-4 sm:left-8 sm:right-auto sm:max-w-md p-4 rounded-lg shadow-xl z-50" style={{ background: 'var(--bg-inverse)', color: 'var(--text-inverse)', border: '1px solid var(--border)' }}>
      <p className="text-sm mb-3">
        We use cookies to improve your experience. By clicking “Accept All”, you agree to our
        <a href="/cookies" className="underline ml-1" style={{ color: 'var(--accent-on-inverse)' }}>Cookie Policy</a>.
      </p>
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => handleAccept('essential')}
          className="px-4 py-2 rounded text-xs font-medium transition"
          style={{ background: 'var(--bg-muted)', color: 'var(--text-primary)' }}
        >
          Accept Essential Only
        </button>
        <button
          onClick={() => handleAccept('all')}
          className="px-4 py-2 rounded text-xs font-medium transition"
          style={{ background: 'var(--accent)', color: 'var(--text-on-accent)' }}
        >
          Accept All
        </button>
      </div>
    </div>
  );

  return typeof document !== 'undefined' ? createPortal(banner, document.body) : banner;
};

export default CookieBanner;